// extracted by mini-css-extract-plugin
module.exports = {"eventHome":"styles_eventHome__JTqJl","more":"styles_more__Y6Rcs","listNotices":"styles_listNotices__1UVh1","notice":"styles_notice__ixFcu"};